import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-chunky-two-select',
    templateUrl: './chunky-two-select.component.html',
    styleUrls: ['./chunky-two-select.component.scss'],
    standalone: false
})
export class ChunkyTwoSelectComponent {

  @Input() description: string;
  @Input() header: string;
  @Input() isModal = false;
  @Input() selected: (key: string) => void;
  @Input() option1: { key: string; value: string };
  @Input() option2: { key: string; value: string };

}
